import { useState, useMemo, useRef } from 'react';
import { detectLinkSelection } from '../../util/notes';
export const useInitializeLinkButtonContext = () => {
    const [modalState, setModalState] = useState({
        open: false,
        title: '',
        href: '',
        initialTitle: '',
        initialLink: '',
    });
    const [isExistingLinkYn, setIsExistingLinkYn] = useState(false);
    const [selectionRange, setSelectionRange] = useState(undefined);
    const [isEmptySelection, setIsEmptySelection] = useState(false);
    const selectionForLink = useRef((ctx, selection) => {
        const { isSelectionLink, selectionRange, linkAttributes, text, empty = false, } = detectLinkSelection(ctx, selection);
        setSelectionRange(selectionRange);
        setModalState(prev => ({
            ...prev,
            open: false,
            href: linkAttributes.href,
            title: text,
            initialTitle: text,
            initialLink: linkAttributes.href,
        }));
        setIsExistingLinkYn(isSelectionLink);
        setIsEmptySelection(empty);
    });
    const contextValue = useMemo(() => {
        return {
            modalState,
            setModalState,
            selectionForLink: selectionForLink.current,
            isExistingLinkYn,
            selectionRange,
            isEmptySelection,
        };
    }, [modalState, isExistingLinkYn, selectionRange, isEmptySelection]);
    return contextValue;
};
//# sourceMappingURL=use_initialize_link_button_context.js.map